import { useEffect, useState, type FormEvent } from 'react'
import { api, type Fakt } from '../api'
import { link } from '../navigation'

function datum(f: Fakt) {
  if (!f.aufgenommenAm) return null
  return new Date(f.aufgenommenAm).toLocaleDateString('de-DE', { timeZone: f.zeitzone ?? undefined })
}

/** Fakten über den Nutzer selbst: aus Notizen erkannt oder von Hand eingetragen. */
export function UeberMich() {
  const [fakten, setFakten] = useState<Fakt[] | null>(null)
  const [neu, setNeu] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)

  useEffect(() => {
    api.ueberMich().then(setFakten).catch((e) => setFehler((e as Error).message))
  }, [])

  const aktion = async (f: () => Promise<void>) => {
    setFehler(null)
    try {
      await f()
    } catch (e) {
      setFehler((e as Error).message)
    }
  }

  const hinzufuegen = (e: FormEvent) => {
    e.preventDefault()
    const text = neu.trim()
    if (!text) return
    aktion(async () => {
      setFakten(await api.ueberMichHinzufuegen(text))
      setNeu('')
    })
  }

  return (
    <div className="person-detail">
      <a href="#personen" className="zurueck">
        ‹ Alle Personen
      </a>

      <section className="karte">
        <h2>Über mich</h2>
        <p className="leise">
          Was du in deinen Notizen über dich selbst sagst, z. B. Geburtstag, Wohnorte oder Familie. Bei jeder Frage steht es
          als Quelle bereit.
        </p>
      </section>

      {fehler && <p className="fehler">{fehler}</p>}

      <h3>Was über dich bekannt ist</h3>
      {fakten?.length === 0 && <p className="leise">Noch nichts.</p>}
      <ul className="fakten-liste">
        {fakten?.map((f) => (
          <li key={f.id} className="karte">
            <span>{f.fakt}</span>
            <span className="leise klein">
              {f.notizId && datum(f) ? <a href={link.notiz(f.notizId)}>{datum(f)}</a> : <span>von Hand</span>}
              <button
                className="link gefahr"
                aria-label="Fakt löschen"
                onClick={() =>
                  confirm(`„${f.fakt}“ löschen?`) &&
                  aktion(async () => {
                    await api.ueberMichLoeschen(f.id)
                    setFakten(fakten.filter((x) => x.id !== f.id))
                  })
                }
              >
                ✕
              </button>
            </span>
          </li>
        ))}
      </ul>

      <form className="karte formular" onSubmit={hinzufuegen}>
        <label>
          Selbst ergänzen
          <input value={neu} maxLength={500} placeholder="z. B. geboren am 4. März 1971" onChange={(e) => setNeu(e.target.value)} />
        </label>
        <div className="knoepfe">
          <button type="submit" disabled={!neu.trim()}>
            Hinzufügen
          </button>
        </div>
      </form>
    </div>
  )
}
